export default __webpack_public_path__ + "static/product-unit-11-everyday-things-e641435b090d41a10afd497d4ac023a9.png";